import type { ReactNode } from 'react';
import { renderMarketingMarkdown } from '@/components/marketing/markdown/renderMarketingMarkdown';
import type { LegalSection } from './markdown';

type Props = {
  section: LegalSection;
};

export default function LegalSectionV2({ section }: Props) {
  const children = renderMarketingMarkdown(section.rawBlock) as ReactNode[];

  return (
    <article id={section.id} className="mb-12 scroll-mt-24 last:mb-0">
      <span className="mb-2 inline-block font-marketing-display text-[44px] font-bold leading-none tracking-[-0.03em] text-lime-500">
        {section.num}
      </span>
      <h3 className="mb-4 font-marketing-display text-[26px] font-bold leading-[1.15] tracking-[-0.02em] text-charcoal-800">
        {section.title}
      </h3>
      <div className="prose-legal space-y-3.5 font-marketing-body text-[15.5px] leading-[1.65] text-charcoal-700">
        {children}
      </div>
    </article>
  );
}
